// NEXT ROUND / DIFFICULTY markup. 2026-09-06 restyle (Eric's spec): big Theo
// with a brief gold sparkle, bank + round progress, three compact difficulty
// choices with growth icons (sprout → branch → olive tree) and supporting
// text, then an explicit "Start Round N →" button. Choices SELECT (default
// Balanced); the start button launches — gameController.startNextRound().
import { icon } from '../ui/icons';

export const nextRoundHTML = /* html */ `
<div id="screenNextRound" class="nextround hidden">
  <div class="nr-hero">
    <div class="nr-sparkle" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i></div>
    <div class="nr-theo char-art tier-1" id="nrTheo" aria-hidden="true">🧑‍🦲</div>
  </div>
  <div class="kicker">Round complete</div>
  <h2 id="nrTitle">Next Round</h2>
  <div class="nr-bank">Bank so far · <b id="nrBank" class="money">$0</b></div>
  <div class="nr-progress" id="nrProgress" aria-hidden="true"></div>
  <div class="nr-q">How should the next round feel?</div>
  <div class="nr-choices">
    <button class="nr-choice" data-d="easier">
      <span class="nr-ic">${icon('sprout', 26)}</span>
      <span class="nr-body"><span class="nr-lbl">Easy</span><span class="nr-sub">Build confidence with the basics.</span></span>
    </button>
    <button class="nr-choice" data-d="same">
      <span class="nr-ic">${icon('branch', 26)}</span>
      <span class="nr-body"><span class="nr-lbl">Balanced</span><span class="nr-sub">A mix of straightforward and challenging questions.</span></span>
    </button>
    <button class="nr-choice" data-d="harder">
      <span class="nr-ic">${icon('tree', 26)}</span>
      <span class="nr-body"><span class="nr-lbl">Hard</span><span class="nr-sub">Test your knowledge with deeper questions.</span></span>
    </button>
  </div>
  <!-- Hard-mode on-ramp (PLAN-gameplay-v2 §3b): the jump is telegraphed BEFORE
       the opt-in — shown only while Hard is the selected choice. -->
  <div class="nr-hardnote" id="nrHardNote"></div>
  <button class="btn nr-start" id="nrStartBtn" type="button">Start next round →</button>
  <div class="nr-quip" id="nrQuip"></div>
</div>`;
